import { render, staticRenderFns } from "./PictoPage.vue?vue&type=template&id=2f148844&scoped=true&"
import script from "./PictoPage.vue?vue&type=script&lang=js&"
export * from "./PictoPage.vue?vue&type=script&lang=js&"
import style0 from "./PictoPage.vue?vue&type=style&index=0&id=2f148844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f148844",
  null
  
)

export default component.exports